import { Component, Mixins } from 'vue-property-decorator';
import SessionManager from '@/helpers/session-manager';
import { ANALYTICS_ACTIONS } from '@/models/enums/analytics-actions.enum';
import AppConfigMixin from '@/mixins/appConfigMixin';

@Component
export default class googleMapsMixin extends Mixins(AppConfigMixin) {
  async getMapUrl() {
    const id =
      this.$store.state.defaultFacility?.id ||
      new SessionManager().getSession().facilityId;
    await this.$store.dispatch('setDefaultFacilityById', id);

    return this.$store.state.defaultFacility.writeReviewUrl;
  }
  async goToMaps() {
    const writeReviewUrl = await this.getMapUrl();
    await this.sendSurveyAnalytics(
      ANALYTICS_ACTIONS.GOOGLE_MAPS_CLICKED,
      this.surveyId!
    );
    SessionManager.deleteSession();
    window.location.href = writeReviewUrl;
  }
}
